// Edit business contact details here — they update across the whole site.
export const SITE = {
  name: "Westline Technologies",
  tagline: "Business Systems | Automation | Workflow Technology",
  location: "Western Australia, Australia",
  email: "admin@westlinetechnologies.com",
  phone: "+61 408 313 146",
  abn: "",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
